var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedeemUnActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2D81F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75:2450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52402 23.7384H8.57205C8.86145 23.7384 9.09607 23.5038 9.09607 23.2144V17.4502H7.52402C7.23462 17.4502 7 17.6848 7 17.9742V23.2144C7 23.5037 7.23462 23.7384 7.52402 23.7384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8C15.7908 8 14 9.79083 14 12C14 14.2091 15.7908 16 18 16C20.2092 16 22 14.2091 22 12C22 9.79083 20.2092 8 18 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 3,
    fill: "#2D81F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.0002,
    cy: 12,
    r: 2.3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4602 24.0178H16.5755C18.3362 23.9968 20.0235 23.4974 21.5118 22.596L24.4358 20.5523C24.9283 20.2065 25.0226 19.5567 24.6978 19.0956C24.3624 18.6135 23.7126 18.4982 23.241 18.8336L20.4323 20.8039C19.531 21.3279 18.4306 21.4432 17.4349 21.1078L14.2035 20.0387C13.931 19.9549 13.7842 19.651 13.8786 19.3786C13.9624 19.1165 14.2349 18.9698 14.5074 19.0432C14.5178 19.0432 18.137 20.217 18.137 20.217C18.7465 20.3997 19.288 20.0548 19.4576 19.5462C19.6357 18.9907 19.3318 18.4038 18.7868 18.2257L13.8576 16.6117C12.7794 16.2193 11.3265 16.3003 10.144 16.9616V22.8278L14.2558 23.7593C15.009 23.925 15.7481 24.0178 16.4602 24.0178Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75:2450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedeemUnActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redeem-un-active.a0ba4d40.svg";
export { ForwardRef as ReactComponent };